export default navigator.geolocation